<template>
  <iframe
          src="http://kibana-proxy.eepos.local/goto/d1971f3fbe00fe8db398b9f757d53344"
          height="700"
          width="100%"
          frameborder="0"
        ></iframe>
</template>
<script>
export default {

}
</script>